/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Issued - ТЗ (знак выпущен), Refused - зТЗ (отказ в регистрации ТЗ), null => зТЗ (заявка в процессе регистрации)
 * @export
 * @enum {string}
 */
export enum ApplicationResultStatus {
  Issued = 'Issued',
  Refused = 'Refused',
}

export function instanceOfApplicationResultStatus(value: any): boolean {
  for (const key in ApplicationResultStatus) {
    if (Object.prototype.hasOwnProperty.call(ApplicationResultStatus, key)) {
      if (
        ApplicationResultStatus[key as keyof typeof ApplicationResultStatus] ===
        value
      ) {
        return true
      }
    }
  }
  return false
}

export function ApplicationResultStatusFromJSON(
  json: any
): ApplicationResultStatus {
  return ApplicationResultStatusFromJSONTyped(json, false)
}

export function ApplicationResultStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ApplicationResultStatus {
  return json as ApplicationResultStatus
}

export function ApplicationResultStatusToJSON(
  value?: ApplicationResultStatus | null
): any {
  return value as any
}
